import React from "react";
import { Skeleton } from "@mui/material";
import { DEFAULT_REF_FIELD } from "@hyro-components/fields/utils";
import { CellWithArrow } from "src/components/collections/List/collections-list/CollectionsList.styles";
import { isNullableField } from "../ExploreTab.utils";
import { REF_CELL_LOADING_TEST_ID } from "../ExploreTab.consts";
import PrimitiveCell from "./PrimitiveCell";

const RefCellDisplay = ({ field, resolvedValue, isEditable, isResolving = false, isUnresolved = false }) => {
  const displayValue =
    !resolvedValue && isNullableField(field) && isEditable ? DEFAULT_REF_FIELD.display_key : resolvedValue;
  const content = isResolving
    ? <Skeleton variant="text" width="70%" data-testid={REF_CELL_LOADING_TEST_ID} />
    : isUnresolved ? null : <PrimitiveCell value={displayValue} />;

  if (!isEditable) return content;
  return <CellWithArrow>{content}</CellWithArrow>;
};

export default RefCellDisplay;
